import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Highlights from "./Highlights";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";

import VideoPlayer from "./VideoPlayer";

import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import axios from "axios";

import ArticleLoader from "../../Common/ArticleLoader";
import ImageLoader from "../../Common/ImageLoader";

// News With ideo
const videoUrl = "https://videos.pexels.com/video-files/4765224/4765224-sd_640_360_24fps.mp4";
const videoUrl2 = "https://videos.pexels.com/video-files/4766165/4766165-sd_960_506_24fps.mp4";

const Hero = () => {
    const [activePipVideo, setActivePipVideo] = useState(null);
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);

    const [headerNews, setHeaderNews] = useState([]);
    const [latestNews, setLatestNews] = useState([]);

    const [categorys, setCategorys] = useState([]);
    const [categoryNews, setCategoryNews] = useState([]);

    const [pageSize, setPageSize] = useState(9);
    const [page, setPage] = useState(1);
    const [articles, setArticles] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    // State to track loaded images
    const [imageLoaded, setImageLoaded] = useState(false);
    const [loadedImages, setLoadedImages] = useState({});

    // Auto change Class Name images
    const [issmallSize, setIsSmallSize] = useState(window.innerWidth < 576);

    const [isTabview, setIsTabView] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => {
            setIsTabView(window.innerWidth < 992);
        };
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        // Function to update screen size
        const handleResize = () => {
            setIsSmallSize(window.innerWidth < 576);
        };

        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    function getAdjustedSummary(title, summary) {
        const baseSummaryLength = 180; // The base length for the summary
        const titleLineLength = 50; // Approximate character count for each line of the title
        const maxTitleLines = 3; // Maximum number of lines the title can take

        // Calculate the number of lines the title occupies
        const titleLines = Math.ceil(title.length / titleLineLength);

        // Calculate how much space remains for the summary based on the title lines
        let adjustedSummaryLength = baseSummaryLength - (titleLines - 1) * 30; // Reduce length per extra line of title

        // Ensure the adjusted summary length is not below a minimum value
        adjustedSummaryLength = Math.max(adjustedSummaryLength, 50);

        // Return the truncated summary based on the adjusted length
        return summary.length > adjustedSummaryLength ? summary.slice(0, adjustedSummaryLength) + "..." : summary;
    }

    const handleChange = (event, value) => {
        setPage(value);

        // Scroll to the targeted section with an offset for a fixed header
        const targetElement = document.getElementById("recentPosts");
        if (targetElement) {
            const isMobile = window.innerWidth <= 767; // Adjust width threshold as needed
            const headerOffset = isMobile ? 100 : 60; // Different offsets for mobile and desktop

            // Use a timeout to allow layout to stabilize before scrolling
            setTimeout(() => {
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: Math.max(0, offsetPosition),
                    behavior: "smooth",
                });
            }, 100); // Delay in milliseconds, adjust if necessary
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getHomeList",
            });
            const output = response.data;
            if (Object.keys(output).length == 4) {
                // const midpoint = Math.floor(headerNews.length / 2);
                // setFirstHalfHeaderNews(headerNews.slice(0, midpoint));
                // setSecondHalfHeaderNews(headerNews.slice(midpoint));
                setHeaderNews(output.header_news);
                setLatestNews(output.latest_news);
                setCategorys(output.categories);
                setCategoryNews(output.category_news);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        // setLoading(false);
    };

    // useEffect(() => {
    //     console.clear();
    // }, []);

    useEffect(() => {
        getAllArticle();
    }, [page]);

    const getAllArticle = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getRecentPosts",
                offset: (page - 1) * pageSize, // Correct offset calculation
                limit: pageSize,
            });
            const output = response.data.data;

            if (output.length > 0) {
                setTotalCount(response.data.totalCount);
                const modifiedOutput = output.map((row) => ({
                    ...row,
                    id: row.pk_ac_key,
                    ac_img: IMAGE_URL + row.file_name,
                }));
                setArticles(modifiedOutput);
            } else {
                setArticles([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setIsLoading(false);
    };
    const totalPages = Math.ceil(totalCount / pageSize); // Calculate total pages

    return (
        <>
            {/* {loading && <ArticleLoader />} */}
            <div className="">
                {/* <Navbar /> */}
                <main className="mt-16">
                    <div className="container">
                        <div className="home-featured">
                            <div className="row font-heading">
                               
                                <div className="col-md-12 col-lg-3 px-0 ">
                                    {isLoading
                                        ? // Display three loaders while data is loading
                                          Array.from({ length: 3 }).map((_, index) => (
                                              <article className=" col-sm-12 col-md-12 col-lg-3 mb-md-3" key={index} style={{ maxWidth: "100%" }}>
                                                  <ArticleLoader width={isTabview ? "100%" : 300} />
                                              </article>
                                          ))
                                        : headerNews.slice(0, 3).map((row, index) => (
                                              <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                                  <Link to={"/detail/" + row.pk_ac_key}>
                                                      <h5 className="post-title font-weight-bold mb-8">{row["ac_name"]}</h5>
                                                      {JSON.parse(row.cat_keys).includes("F1F62C9B88027F35") && (
                                                          <span className="live-now text-danger">Live now</span>
                                                      )}
                                                      <p className="excerpt-2 mb-12">{row["ac_summary"]}</p>
                                                  </Link>
                                              </article>
                                          ))}
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <Highlights />
                                </div>
                                <div className="col-md-12 col-lg-3 px-0 ">
                                    {isLoading
                                        ? // Display three loaders while data is loading
                                          Array.from({ length: 3 }).map((_, index) => (
                                              <article className="col-lg-3 col-md-6 col-sm-12 mb-md-3 w-100" key={index} style={{ maxWidth: "100%" }}>
                                                  <ArticleLoader width={isTabview ? "100%" : 300} />
                                              </article>
                                          ))
                                        : headerNews.slice(3).map((row, index) => (
                                              <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                                  <Link to={"/detail/" + row.pk_ac_key}>
                                                      <h5 className="post-title font-weight-bold mb-8">{row["ac_name"]}</h5>
                                                      {JSON.parse(row.cat_keys).includes("F1F62C9B88027F35") && (
                                                          <span className="live-now text-danger">Live now</span>
                                                      )}
                                                      <p className="excerpt-2 mb-12">{row["ac_summary"].slice(0, 130)}...</p>
                                                  </Link>
                                              </article>
                                          ))}
                                </div>
                            </div>
                        </div>
                        <div className="line-dots mb-20 mt-10"></div>
                        <section className="latest-post mb-20">
                            {" "}
                            <h3 className="widget-header widget-header-style-1 text-center font-weight-bold mb-16 ">
                                <span className="pl-15 pr-15 font-family-normal "># Latest News</span>
                            </h3>
                            <div className="loop-grid row mb-12 mb-md-vd vertical-divider ">
                                {isLoading
                                    ? // Display three loaders while data is loading
                                      Array.from({ length: 4 }).map((_, index) => (
                                          <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                              <ArticleLoader width={300} />
                                          </article>
                                      ))
                                    : latestNews.slice(0, 4).map((row) => (
                                          <>
                                              <article key={row.pk_ac_key} className="col-lg-3 col-md-6 col-sm-12 latest-news-grid px-16">
                                                  <Link to={"/detail/" + row.pk_ac_key}>
                                                      <div className="entry-meta meta-0 mb-8 font-small">
                                                          {JSON.parse(row["tag_master"]).map((item, index) => (
                                                              <a key={item["pk_tag_key"]}>
                                                                  <span className="post-cat position-relative"># {item["tag"]}</span>
                                                              </a>
                                                          ))}
                                                      </div>
                                                      <h5 className="post-title font-weight-bold mb-8">{row["ac_name"]}</h5>
                                                      <p className="excerpt mb-12">
                                                          {getAdjustedSummary(row["ac_name"], row["ac_summary"])}
                                                          {/* {row["ac_summary"].slice(0, 180)}... */}
                                                      </p>
                                                      <figure className="mb-12">
                                                          {JSON.parse(row.additionalFields).map((item, index) => {
                                                              if (index == 0) {
                                                                  return item["base_type"] === "video" ? (
                                                                      <VideoPlayer
                                                                          key={index}
                                                                          src={IMAGE_URL + item["file_name"]}
                                                                          activePipVideo={activePipVideo}
                                                                          setActivePipVideo={setActivePipVideo}
                                                                          currentlyPlaying={currentlyPlaying}
                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                      />
                                                                  ) : (
                                                                      <img
                                                                          key={index}
                                                                          className="img-fluid w-100 h-100"
                                                                          style={{
                                                                              objectFit: "cover",
                                                                              aspectRatio: "10/6",
                                                                          }}
                                                                          src={IMAGE_URL + item["file_name"]}
                                                                          alt=""
                                                                      />
                                                                  );
                                                              }
                                                          })}
                                                      </figure>

                                                      <div className="entry-meta meta-2 text-uppercase font-x-small color-muted">
                                                          {JSON.parse(row.author_info).map((item, index) => (
                                                              <>
                                                                  <a className="float-left mr-10 author-img">
                                                                      <img src={IMAGE_URL + item.profile} alt="" />
                                                                  </a>{" "}
                                                                  By
                                                                  <a>
                                                                      <span className="author-name">{item.first_name + " " + item.last_name}</span>
                                                                  </a>
                                                                  <span className="create-date ml-20">{row.mod_publish_date}</span>
                                                              </>
                                                          ))}
                                                      </div>
                                                  </Link>
                                                  <div class="col-12 d-md-block d-lg-none px-0 my-2">
                                                      <div class="has-top-border mt-20 mt-md-16"></div>
                                                  </div>
                                              </article>
                                          </>
                                      ))}
                            </div>
                            <div className="loop-grid-2 row vertical-divider">
                                {isLoading
                                    ? // Display three loaders while data is loading
                                      Array.from({ length: 4 }).map((_, index) => (
                                          <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                              <ArticleLoader width={300} />
                                          </article>
                                      ))
                                    : latestNews.slice(4).map((row, index) => (
                                          <article key={row.pk_ac_key} className="col-xl-4 col-lg-6 col-md-6 col-sm-12 wow fadeIn animated">
                                              <div className="row flex-md-column flex-lg-row">
                                                  <div className={`col-12 d-md-none d-lg-block first-line-hide ${index === 0 ? "hide-on-mobile" : ""}`}>
                                                      <div className="has-top-border mb-12 mt-lg-1 mt-xl-0"></div>
                                                  </div>
                                                  <div className="col-md-12 col-lg-6 pe-lg-0">
                                                      <div className="entry-meta meta-0 mb-8 font-small ">
                                                          {JSON.parse(row["tag_master"]).map((item, index) => (
                                                              <a key={item["pk_tag_key"]}>
                                                                  <span className="post-cat position-relative"># {item["tag"]}</span>
                                                              </a>
                                                          ))}
                                                      </div>
                                                      <h6 className="post-title mb-8 font-weight-bold">
                                                          <Link to={"/detail/" + row.pk_ac_key}>{row["ac_name"].slice(0, 50)}</Link>
                                                      </h6>
                                                      <p className="excerpt mb-0">{row["ac_summary"]}</p>
                                                  </div>
                                                  <div className="col-md-12 col-lg-6">
                                                      <figure className="mt-sm-3 h-100">
                                                          {JSON.parse(row.additionalFields).map((item, index) => {
                                                              if (index == 0) {
                                                                  return item["base_type"] === "video" ? (
                                                                      <VideoPlayer
                                                                          key={index}
                                                                          src={IMAGE_URL + item["file_name"]}
                                                                          activePipVideo={activePipVideo}
                                                                          setActivePipVideo={setActivePipVideo}
                                                                          currentlyPlaying={currentlyPlaying}
                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                      />
                                                                  ) : (
                                                                      <img
                                                                          key={index}
                                                                          className="w-100"
                                                                          style={{
                                                                              objectFit: "cover",
                                                                          }}
                                                                          height={issmallSize ? "100%" : isTabview ? "200px" : "150px"}
                                                                          src={IMAGE_URL + item["file_name"]}
                                                                          alt=""
                                                                      />
                                                                  );
                                                              }
                                                          })}
                                                      </figure>
                                                  </div>
                                              </div>
                                          </article>
                                      ))}
                            </div>
                        </section>

                        {categorys.map((row, index) => (
                            <section key={row.pk_cat_key} className="the-world mb-16">
                                <h6 className="font-weight-bold widget-header widget-header-style-2 text-center mb-16">
                                    <div className="horizontal-divider w-100 mt-20 mb-20"></div>
                                    {/* <span className="line-dots"></span> */}
                                    <span className="d-block text-uppercase font-family-normal f-18"># {row["cat_name"]}</span>
                                </h6>
                                <div className="loop-grid-3 row vertical-divider">
                                    <div className="col-lg-7 col-md-12">
                                        {isLoading
                                            ? // Display three loaders while data is loading
                                              Array.from({ length: 1 }).map((_, index) => (
                                                  <article className="first-post wow fadeIn animated mb-md-4 mb-lg-0" key={index} style={{ maxWidth: "100%" }}>
                                                      <ImageLoader width={"100%"} height={500} />
                                                  </article>
                                              ))
                                            : categoryNews
                                                  .filter((record) => record.fk_cat_key === row.pk_cat_key)
                                                  .slice(0, 1)
                                                  .map((article) => (
                                                      <article key={article.pk_ac_key} className="first-post wow fadeIn animated mb-md-4 mb-lg-0">
                                                          <figure className="mb-12">
                                                              <Link to={"/detail/" + article.pk_ac_key}>
                                                                  {JSON.parse(article.additionalFields).map((item, index) => {
                                                                      if (index == 0) {
                                                                          return item["base_type"] === "video" ? (
                                                                              <VideoPlayer
                                                                                  key={index}
                                                                                  src={IMAGE_URL + item["file_name"]}
                                                                                  activePipVideo={activePipVideo}
                                                                                  setActivePipVideo={setActivePipVideo}
                                                                                  currentlyPlaying={currentlyPlaying}
                                                                                  setCurrentlyPlaying={setCurrentlyPlaying}
                                                                              />
                                                                          ) : (
                                                                              <>
                                                                                  {!imageLoaded && <ImageLoader width={"100%"} height={500} />}
                                                                                  <img
                                                                                      className="first-post-img w-100"
                                                                                      height={500}
                                                                                      key={index}
                                                                                      src={IMAGE_URL + item["file_name"]}
                                                                                      alt="thumbnail"
                                                                                      style={{
                                                                                          display: imageLoaded ? "block" : "none",
                                                                                      }} // Hide the image until it's loaded
                                                                                      onLoad={() => setImageLoaded(true)}
                                                                                  />
                                                                              </>
                                                                          );
                                                                      }
                                                                  })}
                                                              </Link>
                                                          </figure>
                                                          <div className="post-content text-center plr-5-percent">
                                                              <h2 className="post-title mb-16 position-relative">
                                                                  <Link to={"/detail/" + article.pk_ac_key}>{article.ac_name}</Link>
                                                              </h2>
                                                              <p className="excerpt mb-8">{article.ac_summary}</p>
                                                              <div className="entry-meta meta-0 mb-12 font-small">
                                                                  {JSON.parse(article.tag_master).map((item) => (
                                                                      <Link key={item.pk_tag_key} to={`/tag/${item.pk_tag_key}`}>
                                                                          <span className="post-cat position-relative"># {item.tag}</span>
                                                                      </Link>
                                                                  ))}
                                                              </div>
                                                          </div>
                                                      </article>
                                                  ))}
                                    </div>
                                    <div className="col-lg-5 col-md-12">
                                        <div className="row vertical-divider">
                                            {isLoading
                                                ? // Display three loaders while data is loading
                                                  Array.from({ length: 3 }).map((_, index) => (
                                                      <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                                          <ArticleLoader width={300} />
                                                      </article>
                                                  ))
                                                : categoryNews
                                                      .filter((record) => record.fk_cat_key === row.pk_cat_key)
                                                      .slice(1, 3)
                                                      .map((article) => (
                                                          <article key={article.pk_ac_key} className="col-md-6 wow fadeIn animated category-article">
                                                              <figure className="mb-15">
                                                                  <a>
                                                                      {article.additionalFields &&
                                                                          JSON.parse(article.additionalFields).map((item, index) => {
                                                                              if (index == 0) {
                                                                                  return item["base_type"] === "video" ? (
                                                                                      <VideoPlayer
                                                                                          key={index}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          activePipVideo={activePipVideo}
                                                                                          setActivePipVideo={setActivePipVideo}
                                                                                          currentlyPlaying={currentlyPlaying}
                                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                                      />
                                                                                  ) : (
                                                                                      <img
                                                                                          // className="img-sm-fluid img-fluid w-100"
                                                                                          className={issmallSize ? "img-fluid w-100" : "img-sm-fluid w-100"}
                                                                                          key={index}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          alt=""
                                                                                      />
                                                                                  );
                                                                              }
                                                                          })}
                                                                  </a>
                                                              </figure>
                                                              <h6 className="post-title font-weight-bold mb-10">
                                                                  <Link to={"/detail/" + article.pk_ac_key}>{article.ac_name}</Link>
                                                              </h6>
                                                              <p className="excerpt mb-0">{article.ac_summary}</p>
                                                          </article>
                                                      ))}

                                            <div className="col-12">
                                                <div className="horizontal-divider mb-15 mt-15"></div>
                                            </div>
                                        </div>
                                        <div className="row vertical-divider">
                                            {isLoading
                                                ? // Display three loaders while data is loading
                                                  Array.from({ length: 3 }).map((_, index) => (
                                                      <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                                          <ArticleLoader width={300} />
                                                      </article>
                                                  ))
                                                : categoryNews
                                                      .filter((record) => record.fk_cat_key === row.pk_cat_key)
                                                      .slice(3)
                                                      .map((article) => (
                                                          <article key={article.pk_ac_key} className="col-md-6 wow fadeIn animated">
                                                              <figure className="mb-15">
                                                                  <a>
                                                                      {article.additionalFields &&
                                                                          JSON.parse(article.additionalFields).map((item, index) => {
                                                                              if (index == 0) {
                                                                                  return item["base_type"] === "video" ? (
                                                                                      <VideoPlayer
                                                                                          key={index}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          activePipVideo={activePipVideo}
                                                                                          setActivePipVideo={setActivePipVideo}
                                                                                          currentlyPlaying={currentlyPlaying}
                                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                                      />
                                                                                  ) : (
                                                                                      <img
                                                                                          className="img-sm-fluid img-fluid w-100"
                                                                                          key={index}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          alt=""
                                                                                      />
                                                                                  );
                                                                              }
                                                                          })}
                                                                  </a>
                                                              </figure>
                                                              <h6 className="post-title font-weight-bold mb-10">
                                                                  <Link to={"/detail/" + article.pk_ac_key}>{article.ac_name}</Link>
                                                              </h6>
                                                              <p className="excerpt mb-0">{article.ac_summary.slice(0, 200)}...</p>
                                                          </article>
                                                      ))}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        ))}
                        <div className="line-dots mb-20 mt-10"></div>
                        <section className="recent-new mb-30" id="recentPosts">
                            <div className="row vertical-divider">
                                <div className="col-lg-12 col-md-12">
                                    <h3 className="widget-header widget-header-style-1 text-center font-weight-bold mb-20">
                                        {/* <span className="line-dots"></span> */}
                                        <span className="pl-15 pr-15 font-family-normal "># Recent posts</span>
                                    </h3>
                                    <div className="loop-grid-3">
                                        {isLoading
                                            ? // Display three loaders while data is loading
                                              Array.from({ length: 1 }).map((_, index) => (
                                                  <article className=" row wow fadeIn animated" key={index} style={{ maxWidth: "100%" }}>
                                                      <ArticleLoader width={"100%"} />
                                                  </article>
                                              ))
                                            : articles.slice(0, 1).map((row) => (
                                                  <article className="row wow fadeIn animated">
                                                      <div className="col-md-6 mb-md-0 mb-sm-3">
                                                          <figure className="mb-4 mt-2 h-100">
                                                              <a>
                                                                  {row.additionalFields &&
                                                                      JSON.parse(row.additionalFields).map((item, index) => {
                                                                          if (index == 0) {
                                                                              return item["base_type"] === "video" ? (
                                                                                  <VideoPlayer
                                                                                      key={index}
                                                                                      src={IMAGE_URL + item["file_name"]}
                                                                                      activePipVideo={activePipVideo}
                                                                                      setActivePipVideo={setActivePipVideo}
                                                                                      currentlyPlaying={currentlyPlaying}
                                                                                      setCurrentlyPlaying={setCurrentlyPlaying}
                                                                                  />
                                                                              ) : (
                                                                                  <img
                                                                                      className="w-100"
                                                                                      height={"450px"}
                                                                                      key={index}
                                                                                      src={IMAGE_URL + item["file_name"]}
                                                                                      alt=""
                                                                                  />
                                                                              );
                                                                          }
                                                                      })}
                                                              </a>
                                                              <span className="post-format position-top-right text-uppercase font-small">
                                                                  <i className="ti-stats-up"></i>
                                                              </span>
                                                          </figure>
                                                      </div>
                                                      <div className="col-md-6 align-self-center">
                                                          <div className="post-content text-center plr-5-percent">
                                                              <div className="entry-meta meta-0 mb-15 font-small">
                                                                  {JSON.parse(row.tag_master).map((item) => (
                                                                      <a key={item.pk_tag_key}>
                                                                          <span className="post-cat position-relative"># {item.tag}</span>
                                                                      </a>
                                                                  ))}
                                                              </div>
                                                              <h2 className="post-title mb-30 position-relative divider-wave">
                                                                  <Link to={"/detail/" + row.pk_ac_key}>{row.ac_name}</Link>
                                                              </h2>
                                                              <p className="excerpt">{row.ac_summary}</p>
                                                              {JSON.parse(row.cat_keys).includes("F1F62C9B88027F35") && (
                                                                  <p>
                                                                      <span className="live-now text-danger">Live now</span>
                                                                  </p>
                                                              )}
                                                          </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                          <div className="horizontal-divider mt-15 mb-15"></div>
                                                      </div>
                                                  </article>
                                              ))}
                                        <div className="row vertical-divider mb-3">
                                            <div className="col-md-8 last-divder">
                                                {isLoading
                                                    ? // Display three loaders while data is loading
                                                      Array.from({ length: 4 }).map((_, index) => (
                                                          <article className="row wow fadeIn animated d-block" key={index} style={{ width: "100%" }}>
                                                              <div className="col-md-12 col-lg-12 col-xl-6 w-100">
                                                                  <ArticleLoader width={"100%"} />
                                                              </div>
                                                          </article>
                                                      ))
                                                    : articles.slice(1, 5).map((row, index) => (
                                                          <article key={row.pk_ac_key} className="row wow fadeIn animated">
                                                              <div className="col-md-4">
                                                                  <figure className="mb-md-0 mb-sm-3 h-100">
                                                                      {row.additionalFields &&
                                                                          JSON.parse(row.additionalFields).map((item, index) => {
                                                                              if (index == 0) {
                                                                                  return item["base_type"] === "video" ? (
                                                                                      <VideoPlayer
                                                                                          key={index}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          activePipVideo={activePipVideo}
                                                                                          setActivePipVideo={setActivePipVideo}
                                                                                          currentlyPlaying={currentlyPlaying}
                                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                                      />
                                                                                  ) : (
                                                                                      <img
                                                                                          className="w-100"
                                                                                          key={index}
                                                                                          height={"170px"}
                                                                                          src={IMAGE_URL + item["file_name"]}
                                                                                          alt="article thumbnail"
                                                                                      />
                                                                                  );
                                                                              }
                                                                          })}
                                                                  </figure>
                                                              </div>
                                                              <div className="col-md-8 pl-0">
                                                                  <div className="entry-meta meta-0 mb-8 font-small">
                                                                      {JSON.parse(row.tag_master).map((item) => (
                                                                          <a key={item.pk_tag_key}>
                                                                              <span className="post-cat position-relative"># {item.tag}</span>
                                                                          </a>
                                                                      ))}
                                                                  </div>
                                                                  <h6 className="post-title mb-8 font-weight-bold">
                                                                      <Link to={"/detail/" + row.pk_ac_key}>{row.ac_name}</Link>
                                                                  </h6>
                                                                  <p className="excerpt mb-0">{row.ac_summary}</p>
                                                              </div>
                                                              <div className="col-md-12">
                                                                  {index < articles.slice(1, 5).length - 1 && (
                                                                      <div className="horizontal-divider mt-15 mb-15"></div>
                                                                  )}
                                                                  {/* <div className="horizontal-divider mt-15 mb-15"></div> */}
                                                              </div>
                                                          </article>
                                                      ))}
                                            </div>
                                            <div className="col-md-4 ">
                                                {isLoading
                                                    ? // Display three loaders while data is loading
                                                      Array.from({ length: 4 }).map((_, index) => (
                                                          <article className="wow fadeIn animated " key={index} style={{ maxWidth: "100%" }}>
                                                              <ArticleLoader width={"100%"} />
                                                          </article>
                                                      ))
                                                    : articles.slice(5, 9).map((row) => (
                                                          <article key={row.pk_ac_key} className="wow fadeIn animated">
                                                              <h6 className="post-title mb-8 font-weight-bold">
                                                                  <Link to={"/detail/" + row.pk_ac_key}>{row.ac_name}</Link>
                                                              </h6>
                                                              <p className="excerpt mb-0">{row.ac_summary}</p>
                                                              <div className="horizontal-divider mt-15 mb-12"></div>
                                                          </article>
                                                      ))}
                                            </div>
                                        </div>

                                        <div className="pagination-area border-bottom-2 font-heading wow fadeIn animated">
                                            <div className="container ">
                                                <div className="row mt-2 mb-2 ">
                                                    <div className="px-0 col-xl-12">
                                                        <div className="single-wrap d-flex justify-content-center">
                                                            <Stack spacing={2}>
                                                                {/* <Typography>Page: {page}</Typography> */}
                                                                <Pagination count={totalPages} page={page} onChange={handleChange} />
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
        </>
    );
};

export default Hero;
